import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { flow } from 'lodash/fp'
import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AppState } from 'store'
import { useNotesUi } from './notesUi'

const { actions, reducer } = createSlice({
  name: 'notesCallout',
  initialState: {} as INotesCalloutState,
  reducers: {
    show: () => ({
      showCallout: true
    }),
    hide: () => ({
      showCallout: false,
      error: undefined
    }),
    failure: (state, action: PayloadAction<Error>) => ({
      ...state,
      error: action.payload
    })
  }
})

export { reducer as notesCalloutReducer }

const rootSelector = (state: AppState) =>
  state.modules.advisory.modules.rdot360.secondaryHeader.notes.notesCallout

const getShouldShowCallout = flow(rootSelector, (x) => x.showCallout)
const getPanelError = flow(rootSelector, (x) => x.error)

export interface INotesCalloutState {
  showCallout?: boolean
  error?: Error
}

export const useNotesCallout = () => {
  const { resetActiveIndex } = useNotesUi()
  const dispatch = useDispatch()

  const hide = useCallback(() => {
    dispatch(actions.hide())
    resetActiveIndex()
  }, [dispatch, resetActiveIndex])

  const show = useCallback(() => {
    dispatch(actions.show())
  }, [dispatch])

  const setError = useCallback(
    (e: Error) => {
      dispatch(actions.failure(e))
    },
    [dispatch]
  )

  const showCallout = useSelector(getShouldShowCallout)

  const error = useSelector(getPanelError)

  return {
    hide,
    show,
    setError,
    showCallout,
    error
  }
}
